import subscriptionService from "@/services/salles/SubscriptionService";
import notif from "@/services/common/NotificationHelperService";
import i18n from "@/i18n";

// retrieve the corresponding resource from shared stores instead of returning a new resource object
function getStoredResource(rootGetters, resource) {
  switch (resource.type) {
    case "room":
      return rootGetters["roomModule/getRoomById"](resource.id);
    case "desk":
      return rootGetters["deskModule/getDeskById"](resource.id);
    case "equipment":
      return rootGetters["equipmentModule/getEquipmentById"](resource.id);
  }
  throw new Error("invalid resource type");
}

function getStoredUser(rootGetters, userId) {
  return rootGetters["userModule/getUserById"](userId);
}

function getCurrentUser(rootGetters) {
  return rootGetters["userModule/getCurrentUser"];
}

function subscribeImpl(dispatch, res, un) {
  return new Promise((resolve, reject) => {
    res
      .then(() => {
        resolve();
        notif.showSuccess(
          dispatch,
          i18n.t(`messageStores.${un ? "un" : ""}subscribeSuccess`)
        );
      })
      .catch((e) => {
        reject(e);
        notif.showError(
          dispatch,
          i18n.t(`messageStores.${un ? "un" : ""}subscribeError`)
        );
      });
  });
}

const actions = {
  subscribeUserToResource({ dispatch }, sub) {
    return subscribeImpl(
      dispatch,
      subscriptionService.subscribeUserToResource(sub.user.id, sub.resource.id)
    );
  },

  unsubscribeUserFromResource({ dispatch }, sub) {
    return subscribeImpl(
      dispatch,
      subscriptionService.unsubscribeUserFromResource(
        sub.user.id,
        sub.resource.id
      ),
      true
    );
  },

  subscribeToResource({ rootGetters, dispatch }, resource) {
    return subscribeImpl(
      dispatch,
      subscriptionService.subscribeUserToResource(
        getCurrentUser(rootGetters).id,
        resource.id
      )
    );
  },

  unsubscribeFromResource({ rootGetters, dispatch }, resource) {
    return subscribeImpl(
      dispatch,
      subscriptionService.unsubscribeUserFromResource(
        getCurrentUser(rootGetters).id,
        resource.id
      ),
      true
    );
  },

  getSubscribedResourcesByUser({ rootGetters, dispatch }, user) {
    return new Promise((resolve, reject) => {
      subscriptionService
        .getResourcesByUser(user.id)
        .then((response) => {
          const resources = [];
          for (const resource of response.data)
            resources.push(getStoredResource(rootGetters, resource));
          resolve(resources);
        })
        .catch((e) => {
          reject(e);
          notif.showError(
            dispatch,
            i18n.t("messageStores.subscribedResourcesByUserError")
          );
        });
    });
  },

  getSubscribedResources({ rootGetters, dispatch }) {
    return actions.getSubscribedResourcesByUser(
      { rootGetters, dispatch },
      getCurrentUser(rootGetters)
    );
  },

  getSubscribedUsersByResource({ rootGetters, dispatch }, resource) {
    return new Promise((resolve, reject) => {
      subscriptionService
        .getUsersByResource(resource.id)
        .then((response) => {
          const users = [];
          for (const userId of response.data)
            users.push(getStoredUser(rootGetters, userId));
          resolve(users);
        })
        .catch((e) => {
          reject(e);
          notif.showError(
            dispatch,
            i18n.t("messageStores.subscribedUsersByResourceError")
          );
        });
    });
  },
};

export default {
  namespaced: true,
  actions,
};
